import React from 'react';
import { match } from 'ts-pattern';

import {
  ExampleTypeEnum,
  SOURCE_TYPES,
  SourceConfig,
  SourceConfigAgentLogs,
  SourceConfigCompletionLogs,
  SourceConfigJson,
  SourceConfigModelInvocationLogs,
  SourceConfigSnowflake,
  SourceTypeEnum
} from '@/types/evals';

import { JsonConfigForm } from './JsonConfigForm';
import { MasLogsConfigForm } from './MasLogsConfigForm';
import { SnowflakeConfigForm } from './SnowflakeConfigForm';

type StepSourceTypeProps = {
  sourceType: SourceTypeEnum;
  sourceName: string;
  sourceDescription?: string;
  initialData?: {
    example_type: ExampleTypeEnum;
    config: SourceConfig;
  };
  onNext: ( data: {
    example_type: ExampleTypeEnum;
    config: SourceConfig;
  } ) => void;
  onCancel: () => void;
  onBack: () => void;
  isPending?: boolean;
  isEditMode: boolean;
};

export const StepSourceType: React.FC<StepSourceTypeProps> = ( props ) => {
  const { sourceType, sourceName, sourceDescription, onNext, initialData, ...rest } = props;

  return match( sourceType )
    .with( SOURCE_TYPES.SNOWFLAKE, ( sourceType ) => (
      <SnowflakeConfigForm
        { ...rest }
        source_name={ sourceName }
        source_description={ sourceDescription }
        source_type={ sourceType }
        initialData={ initialData as { example_type: ExampleTypeEnum; config: SourceConfigSnowflake } | undefined }
        onSubmit={ onNext }
      />
    ) )
    .with( SOURCE_TYPES.JSON, ( sourceType ) => (
      <JsonConfigForm
        { ...rest }
        source_name={ sourceName }
        source_description={ sourceDescription }
        source_type={ sourceType }
        initialData={ initialData as { example_type: ExampleTypeEnum; config: SourceConfigJson } | undefined }
        onSubmit={ onNext }
      />
    ) )
    .with( SOURCE_TYPES.AGENT_ACTION_LOGS, ( ) => (
      <MasLogsConfigForm
        { ...rest }
        logType="agent"
        source_name={ sourceName }
        source_description={ sourceDescription }
        initialData={ initialData as { example_type: 'conversation'; config: SourceConfigAgentLogs } | undefined }
        onSubmit={ onNext }
      />
    ) )
    .with( SOURCE_TYPES.MODEL_INVOCATION_LOGS, ( ) => (
      <MasLogsConfigForm
        { ...rest }
        logType="model"
        source_name={ sourceName }
        source_description={ sourceDescription }
        initialData={ initialData as {
          example_type: 'conversation';
          config: SourceConfigModelInvocationLogs
        } | undefined }
        onSubmit={ onNext }
      />
    ) )
    .with( SOURCE_TYPES.COMPLETION_LOGS, ( ) => (
      <MasLogsConfigForm
        { ...rest }
        logType="completion"
        source_name={ sourceName }
        source_description={ sourceDescription }
        initialData={ initialData as {
          example_type: ExampleTypeEnum;
          config: SourceConfigCompletionLogs
        } | undefined }
        onSubmit={ onNext }
      />
    ) )
    .exhaustive( ( sourceType: unknown ) => {
      console.warn( 'Unknown source type', sourceType );
      return (
        <div>
          <p>Unknown source type: {`${ sourceType }`}</p>
        </div>
      );
    } );
};
